var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10809_3135)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10809_3135)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10809_3135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 1.83325C5.9387 1.83325 1.83203 5.93992 1.83203 10.9999C1.83203 16.0599 5.9387 20.1666 10.9987 20.1666C16.0587 20.1666 20.1654 16.0599 20.1654 10.9999C20.1654 5.93992 16.0587 1.83325 10.9987 1.83325ZM15.2062 6.94825L9.16536 12.9891L6.7912 10.6241L5.4987 11.9166L9.16536 15.5833L16.4987 8.24992L15.2062 6.94825Z",
    fill: "#009CA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2062 7.33325L9.16536 13.1981L6.7912 10.902L5.4987 12.1569L9.16536 15.7167L16.4987 8.59701L15.2062 7.33325Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10809_3135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10809_3135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10809_3135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.cb0f1c623e601531a9ef90949e6be691.svg";
export { ForwardRef as ReactComponent };